import { useState } from "react";

import CoverflowView from "./CoverflowView/CoverflowView";
import CompactView from "./CompactView/CompactView";

import "./Carousel.scss";

const Carousel = ({
  slides,
  variant = "compact",
  itemsVisible,
  itemWidth = 230,
  itemHeight = 238,
  withRightFade,
  renderItem,
  onSlideClick,
  mobileExtraButton,
  isMobile
}) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) =>
      (prev - 1 + slides.length) % slides.length
    );
  };

  return (
    <div className={`carousel carousel__${variant}`}>
      {variant === "coverflow" ? (
        <CoverflowView
          slides={slides}
          currentSlide={currentSlide}
          prevSlide={prevSlide}
          nextSlide={nextSlide}
          isMobile={isMobile}
        />
      ) : (
        <CompactView
          slides={slides}
          itemsVisible={itemsVisible}
          itemWidth={itemWidth}
          itemHeight={itemHeight}
          renderItem={renderItem}
          onSlideClick={onSlideClick}
          withRightFade={withRightFade}
          mobileExtraButton={mobileExtraButton}
          isMobile={isMobile}
        />
      )}
    </div>
  );
};

export default Carousel;